import React from 'react'

// material ui
import Box from '@mui/material/Box'

// components
import Typography from '@mui/material/Typography'
import RetailProduct from './RetailProduct'

// helpers
import { hasDays } from 'lib/cart/decorators/cartProduct'

const Camper = props => {
  const {
    camper, // via withQuery
    cartForm, // via redux state
    account // via props
  } = props

  const cartProducts = cartForm.cartProducts.filter(
    cartProduct => cartProduct.camper.id === camper.id && hasDays(cartProduct)
  )

  if (cartProducts.length === 0) {
    return null
  }

  return (
    <Box mb={2}>
      <Typography fontWeight='fontWeightBold'>{camper.name}</Typography>
      {cartProducts.map(cartProduct => (
        <Box key={`${cartProduct.camper.id}-${cartProduct.product.id}`}>
          <RetailProduct
            key={cartProduct.id}
            cartProduct={cartProduct}
            camper={camper}
            account={account}
          />
        </Box>
      ))}
    </Box>
  )
}

export default Camper
